import { useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';
import { Spinner } from '../../../components';
import FetchError from '../../../components/generic/FetchError';
import { FETCH_LOCATION_DIVISIONS } from '../queries/RiskHub';
import NoAvailableData from '../../../components/assets/NoAvailableData';
import FinancialData from '../../../components/common/FinancialData';
import QueryErrorBoundary from '../../../components/error-handling';

const DivisionsSupported = () => {
  let [searchParams] = useSearchParams();

  const locationUuid = searchParams.get('location');

  const FITTED_DIVISIONS = 4;

  const { data, loading, error } = useQuery(FETCH_LOCATION_DIVISIONS, {
    variables: {
      filter: { locationUuid },
    },
    skip: !locationUuid,
  });

  const riskHubData = data?.divisionsSupported;

  const IS_LONG_LIST = riskHubData?.length > FITTED_DIVISIONS;

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <>
      <QueryErrorBoundary error={error}>
        <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative">
          <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
            DIVISIONS SUPPORTED
          </h2>
          <div className="h-[200px] pt-5 pb-4 flex justify-center items-center relative">
            {riskHubData ? (
              <div
                className={`w-full h-full overflow-y-auto flex flex-col gap-2 pl-4`}
              >
                {riskHubData.length > 0 ? (
                  <>
                    <div
                      className={`h-5/6 w-0 border border-secondary-100 border-dashed absolute ${
                        IS_LONG_LIST ? 'right-[4.8rem]' : 'right-[5rem]'
                      } top-1/2 transform -translate-y-1/2`}
                    ></div>
                    <div className="tracking-wider text-xsm font-bold absolute top-1 right-[5.5rem]">
                      Revenue
                    </div>
                    <div className="text-xsm font-bold absolute top-1 right-1.5">
                      % Supported
                    </div>
                    {riskHubData.map((item: any) => (
                      <div className="flex items-center justify-between">
                        <div>
                          <h4 className="text-primary-100 text-sm font-bold tracking-wider">
                            {item?.division}
                          </h4>
                        </div>
                        <div
                          className={`flex items-center justify-between  min-w-[100px]  ${
                            IS_LONG_LIST ? 'mr-6' : 'mr-8'
                          }`}
                        >
                          <div className="text-sm text-blue font-bold">
                            {item.totalSupported === 0 ? (
                              '--'
                            ) : (
                              <FinancialData text={item.totalSupported || 0} />
                            )}
                          </div>
                          <div className="text-sm text-blue font-normal">
                            {item.totalPercentage === 0
                              ? '--'
                              : item.totalPercentage.toFixed(0) + '%'}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <NoAvailableData />
                )}
              </div>
            ) : (
              <NoAvailableData helpText="Select a location first" />
            )}
          </div>
        </div>
      </QueryErrorBoundary>
    </>
  );
};

export default DivisionsSupported;
